import {Component, inject, OnInit} from '@angular/core';
import {Router, RouterOutlet} from '@angular/router';
import {ConfirmationService, MessageService} from 'primeng/api';
import {DialogService} from 'primeng/dynamicdialog';
import {PrimeNgImportsModule} from '../../sdk/src/prime-ng-imports';
import {KeycloakService} from '../../sdk/src/services/keycloak.service';
import {Oo8EventService} from '../../sdk/src/services/oo8-event.service';
import {environment} from '../environments/environment';
import {CpmCApiBridge} from './cpmc-api-bridge';
import {SdkBridge} from './sdk-bridge';
import {GlobalsService} from './services/globals.service';
import {SessionService} from './services/session.service';

/**
 * Application main component
 */
@Component({
    selector: 'app-root',
    imports: [RouterOutlet, PrimeNgImportsModule],
    templateUrl: './app.component.html',
    providers: [MessageService, DialogService, ConfirmationService]
})
export class AppComponent implements OnInit {
    private readonly globalsService: GlobalsService = inject(GlobalsService);
    private readonly keycloakService: KeycloakService = inject(KeycloakService);

    private router: Router = inject(Router);
    private sessionService: SessionService = inject(SessionService);
    private messageService: MessageService = inject(MessageService);
    private dialogService: DialogService = inject(DialogService);
    private confirmationService: ConfirmationService = inject(ConfirmationService);
    public oo8EventService: Oo8EventService = inject(Oo8EventService);

    protected isReady = false;
    protected error = false;

    public title = 'oo8-cpm-client';

    // ===============================================================
    // ===============================================================

    /**
     * Constructor
     */
    constructor() {
        this.globalsService.keycloakService = this.keycloakService;
        this.globalsService.router = this.router;
        this.globalsService.sessionService = this.sessionService;
        this.globalsService.messageService = this.messageService;
        this.globalsService.dialogService = this.dialogService;
        this.globalsService.confirmationService = this.confirmationService;
        this.globalsService.oo8EventService = this.oo8EventService;

        SdkBridge._inject();
        CpmCApiBridge._inject();
    }

    // ===============================================================
    // ===============================================================

    /**
     * On init
     */
    public async ngOnInit() {
        try {
            this.manageIconEnvironment();

            if (!(await this.keycloakService.init())) {
                this.keycloakService.redirectToLogin();
                return;
            }
            await this.sessionService.init();

            this.oo8EventService.init();

            await this.globalsService.sessionService.getRouteContextIsReadyPromise();

            this.isReady = true;
        } catch (error) {
            console.error('Error while initializing app', error);
            this.error = true;
        }
    }

    /**
     * Manage the favicon based on the branch type
     */
    private manageIconEnvironment() {
        let faviconPath: string;
        switch (environment.appEnvironment) {
            case 'pre-production':
                faviconPath = 'images/logo/orange_logo_pre_prod.svg';
                break;
            case 'production':
                faviconPath = 'images/logo/orange_logo.svg';
                break;
            default:
                faviconPath = 'images/logo/orange_logo_dev.svg';
                break;
        }

        // Update favicon link element
        const favicon = document.querySelector('link[rel="icon"]');
        if (favicon) {
            favicon.setAttribute('href', faviconPath);
        }
    }
}
